import Body from "commons/card/Body";
import { default as Card } from "commons/card/CollapsableCard";
import Header from "commons/card/Header";
import LoadingCard from "commons/card/LoadingCard";
import * as r from "constants/routes";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { getSearchParams } from "../../../../commons/models/params";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useGetInventaireQuery } from "../../../../redux/api/cache";

export default function InventoryOptionCardTemplate(props) {
  const popsMemo = useMemo(() => props, [props]);
  const [params, setParams] = useState(props.tabOption.params(props.num));
  const cardRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const { data, isLoading } = useGetInventaireQuery({ query: params });

  useEffect(() => {
    setParams(props.tabOption.params(props.num));
  }, [props.num, props.tabOption, props.tabOption.params]);

  const navigateTo = (e) => {
    let params = getSearchParams(r.INV_KEY, location.search);
    navigate(
      `${location.pathname}/${r.INV_KEY}=${params}/${popsMemo.tabOption.key}=${e}/${popsMemo.tabOption.key}`
    );
  };

  const dataComponent = (data) => {
    if (
      data.data === undefined ||
      JSON.stringify(data.data) === JSON.stringify({})
    )
      return { data: { data: [] }, meta: data.meta };
    return data;
  };

  return isLoading ? (
    <LoadingCard title={`Chargement ${popsMemo.tabOption.label}...`} />
  ) : (
    <div ref={cardRef}>
      <Card expanded={true}>
        <Header title={`${popsMemo.tabOption.label} `}></Header>
        <Body>
          {React.cloneElement(popsMemo.children, {
            data: dataComponent(data),
            dataKey: props.tabOption.key,
            product: props.product,
            inventory: props.inventory,
            navigateTo,
            setParams,
            params,
          })}
        </Body>
      </Card>
    </div>
  );
}

InventoryOptionCardTemplate.propTypes = {
  inventory: PropTypes.bool,
  num: PropTypes.number,
  product: PropTypes.any,
  tabOption: PropTypes.shape({
    key: PropTypes.any,
    params: PropTypes.any,
    path: PropTypes.any,
  }),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
